const config = {
  clientShortName: 'clarocl',
  title: 'Claro Chile',
  email: 'info@toolboxtve.com'
}

export default config;
